module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/whitelist_ca.json
// module id = 334
// module chunks = 0